import React from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'

const SuperAdminReports = () => {
    return (
        <>
            <AdminDashboardLayout>
                <div className="sample-setting-box mt-4">
                    <h1 className='home-main-heading mb-4'>Reports</h1>

                    <div className="block-user-list">
                        <span>John Doe</span>
                        {/* <a href="#">Unblock</a> */}
                    </div>

                    <div className="block-user-list">
                        <span>John Doe</span>
                        {/* <a href="#">Unblock</a> */}
                    </div>

                    <div className="block-user-list">
                        <span>John Doe</span>
                        {/* <a href="#">Unblock</a> */}
                    </div>
                </div>
            </AdminDashboardLayout>
        </>
    )
}

export default SuperAdminReports